export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"PT. Streamworx Reka Solusi provides enterprise IT solutions since 2014: Cloud Native, IAM, SOA, Observability, and Managed Services for your company's digital transformation."},{"name":"keywords","content":"IT enterprise Indonesia, Cloud Native, IAM, SOA, Observability, Managed Services, digital transformation, IT consultant"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Streamworx Solutions"},{"property":"og:locale","content":"en_US"},{"property":"og:locale:alternate","content":"id_ID"},{"property":"og:image","content":"/images/seo/og-image-streamworx.jpg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image:type","content":"image/jpeg"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@streamworx"},{"name":"twitter:title","content":"Streamworx Solutions"},{"name":"twitter:description","content":"@streamworx_id"},{"name":"twitter:image","content":"/images/seo/og-image-streamworx.jpg"},{"name":"robots","content":"index, follow"},{"name":"author","content":"PT. Streamworx Reka Solusi"},{"name":"theme-color","content":"#174F7E"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"en"},"title":"Streamworx - Trusted Enterprise Technology Partner in Indonesia"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false